function Terms() {
  return (
    <div className="h-full justify-center items-center w-full px-7 md:px-14 lg:px-28 my-10 leading-5">
      <p className="text-center font-bold text-xl">Terms of Service</p>
      
      <p>Thank you for using ProjectChef.io</p><br />
      <p>This website is operated by BRAINIT CONSULTING LTD.</p><br />
      <p>
        These Terms of Use, together with any other terms, conditions and
        policies referred to herein (these &quot;Terms&quot;), constitute a
        legally binding agreement governing your access to and use of
        ProjectChef.io via the website or by any other means.
      </p>
      <br />
      <p>These Terms are defined between:</p>
      <br />
      <p>
        BRAINIT CONSULTING LTD, a limited liability company whose registered
        office is located at&nbsp;
      </p> <br />
      <p>71-75, Shelton Street</p>
      <p>London</p>
      <p>WC2H 9JQ</p>
      <p>United Kingdom</p>
      <br />
      <p>
        which develops, maintains and operates the ProjectChef.io Services
        (&ldquo;ProjectChef&rdquo;,&rdquo;us&rdquo; or &ldquo;We&rdquo;;)
      </p> <br />
      <p>And</p>
      <p> <br />
        You, individually, or on behalf of your employer or any other entity you
        represent (&quot;you&quot; or &quot;your&quot;).
      </p> 
      <br />
      <p>
        In the event that you represent your employer or other entity, you
        hereby represent that you have all legal authority necessary to bind
        your employer or such entity to these Terms; and having read and
        understood these Terms, you accept these Terms on behalf of your
        employer.
      </p>
      <br />
      <p>
        Please note that you are considered an authorized representative of your
        employer, if you are using your employer&rsquo;s email address to sign
        up for this service, or if you are an admin.
      </p>
      <br />
      <p>
        By signing up for and using our Service, you agree to be bound by the
        following terms and conditions. Please read them carefully.&nbsp;
      </p>
      <br />
      <li className="font-semibold">OUR Service</li><br />
      <p>
        ProjectChef.io is a project management SAAS (Software As A Service)
        application, which intend to help the project manager and his/her team
        to plan, execute, coordinates and collaborate within his/her projects
        (the &quot;Service&quot;).
      </p>
      <br />
      <li className="font-semibold">Access to OUR service</li>
      <br />
      <p>The Service is offered online.</p>
      <br />
      <p>
        You can log on at any time - with the exception of maintenance periods.
        This includes:
      </p>
      <p>- 24 hours a day,&nbsp;</p>
      <p>- 7 days a week&nbsp;</p>
      <p>- including Sundays and public holidays</p>
      <br />
      <li className="font-semibold">User Account</li>
      <p>
        &nbsp;You must provide accurate and complete information when creating
        an account.
      </p>
      <p>
        &nbsp;You are responsible for maintaining the confidentiality of your
        account credentials.
      </p>
      <p>
        &nbsp;You agree to notify us immediately of any unauthorized access or
        use of your account.
      </p>
      <br />
      <li className="font-semibold">Use of the Service</li>
      <p>
        <br />
      </p>
      <p>
        The Service is intended for lawful purposes only. You agree not to use
        the Service to violate any applicable laws, regulations, or the rights
        of others.
      </p>
      <br />
      <li className="font-semibold">Service modification or interruption</li>
      <br />
      <p>
        We have the right to add, modify or discontinue any feature,
        functionality or other tool with respect to the Service and/or the Site
        at our own discretion and without further notice. However, if we make a
        drastic change to the basic functionality of the Service, we will notify
        you by posting an announcement on the website and/or via the Service or
        by e-mail.
      </p>
      <br />
      <li className="font-semibold">Account de-activation&nbsp;</li>
      <br />
      <p>
        Upon termination requesting your account de-activation by sending an
        email to{" "}
        <a data-fr-linked="true" href="mailto:support@chefproject.io">
          support@chefproject.io
        </a>
        , and in the case you are admin of your organization, &nbsp;ProjectChef
        will no longer be responsible for hosting the Data generated by you as
        part of the Application Services.
      </p>
      <p>
        ProjectChef reserves the right to delete and destroy your
        organization&rsquo;s identifiers and data managed as part of the
        solution in case you or your team have not logged on to our service for
        more than one year.
      </p>
      <br />
      <li className="font-semibold">Technical assistance</li>
      <br />
      <p>
        Support is provided to customers by emailing our support team on :
        &nbsp;
        <a className="text-primary-500" href="mailto:support@projectchef.io">
          support@projectchef.io
        </a>
      </p>
    </div>
  );
}

export default Terms;
